import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "../../Newsletter/MailchimpForm";
import logo from '../img/Logo.png';
import Resume_Icon from '../img/Resume_Icon.png';
import LinkedIn_Icon from '../img/LinkedIn_Icon.svg';
import GitHub_Icon from '../img/GitHub_Icon.svg';
import Email_Icon from '../img/Email_Icon.png';
import links from "../../../assets/data/links.json";
import './Footer.css';
import { Link } from "react-router-dom";
export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end" >
            <div className="social-icon">
              <a href="mailto:yapzhewei2002@gmail.com?subject=Hi, nice to meet you!&body=Hi Andrew," ><img src={Email_Icon} alt="Email Icon" /></a>
              <a href="https://www.linkedin.com/in/yapzhewei/" target="_blank" rel="noopener noreferrer"><img src={LinkedIn_Icon} alt="LinkedIn Icon" /></a>
              <a href="https://github.com/andrewzw" target="_blank" rel="noopener noreferrer"><img src={GitHub_Icon} alt="GitHub Icon" /></a>
              <a href={links.resumeLink} target="_blank" rel="noopener noreferrer"><img src={Resume_Icon} alt="Resume Icon" /></a>
            </div>
            <p>Andrew's Portfolio</p>
            <Link to="/references" className="linkStyle">References</Link>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
